import { ApiBaseFront } from '../api-base-front';

export class ApiGetXml extends ApiBaseFront {
  constructor(kijShopCd: string, shopOrderId: string, fileName: string[]) {
    super(
      'GET',
      `/api/v1/orderxml/${kijShopCd}`,
      'JSON',
      {
        path: fileName.map((v) => `${kijShopCd}/${shopOrderId}/${v}`),
      },
    );
  }
}
